import { useState } from 'react';

const abortController = () => {
	let abortController = new AbortController();

	const abort = (reason) => {
		abortController.abort(reason);
		abortController = new AbortController();
	};

	return {
		get abort() {
			return abort;
		},
		get controller() {
			return abortController;
		},
		get signal() {
			return abortController.signal;
		},
	};
};

const useAbortController = () => useState(abortController())[0];
export default useAbortController;
